import { render } from "./Footer_AS.vue?vue&type=template&id=4f823111"
const script = {}

import "./Footer_AS.vue?vue&type=style&index=0&id=4f823111&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__